import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { Client } from 'src/app/interfaces/client';
import { SuperAdminService } from 'src/app/services/api/super-admin.service';
import { DownloadService } from 'src/app/services/download.service';
import { ErrorService } from 'src/app/services/error.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';
import { ClientInfoComponent } from './modals/client-info/client-info.component';

@Component({
    selector: 'app-client-admin',
    templateUrl: './client-admin.component.html',
    styleUrls: ['./client-admin.component.scss']
})

export class ClientAdminComponent implements OnInit, OnDestroy {

    public title : string = "Medimail Patient - Admin Client";

    public clients: Client[] = [];
    
    displayedColumns: string[] = ['name','actions'];

    //@ts-ignore
    public tabClients: MatTableDataSource<Client>;

    //@ts-ignore
    @ViewChild('paginator') paginator: MatPaginator;

    //@ts-ignore
    @ViewChild(MatSort) sort: MatSort;

    tabUpdated: boolean = false;

    //@ts-ignore
    subscription: Subscription;

    public errorMessageListClient : string = '';
    public errorTypeListClient : string = '';

    public errorMessageLoadClient: string = '';
    public errorTypeLoadClient: string = '';

    @ViewChild('uploadFileInput') fileInput!: ElementRef;

    resSuccess: string[] = [];
    resError: string[] = [];

    fileUpload: boolean = false;
    
    constructor(public userService: UserService, 
                public route: Router,
                private errorService: ErrorService,
                public superAdminService: SuperAdminService,
                private titleService: Title,
                private modalService: NgbModal,
                private loader: LoadingService,
                private downloadService: DownloadService,
                private translate: TranslateService,
                private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {

        this.titleService.setTitle(this.title);

        this.clients = this.activatedRoute.snapshot.data.clients.content;

        this.loadTabClient(this.clients);

        // Rafraîchissement toutes les 30 secondes quand il y a une modification
        this.subscription = timer(0,30000).pipe(map(() => {
            if (!this.tabUpdated) {
                this.loadTabClient();
            }
        })).subscribe();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    loadTabClient(tabClient: Client[] = []) {
        if (tabClient.length > 0) {
            this.tabClients = new MatTableDataSource(this.clients);
            setTimeout(() => this.tabClients.paginator = this.paginator);
            this.tabClients.sort = this.sort;
            this.tabClients.filterPredicate = (data: Client, filter: string) => {
                    return data.name.trim().toLowerCase().includes(filter);
            };
        } else {
            this.superAdminService.getClient().subscribe((res) => {
                if (res.result == "SUCCESS") {
                    this.tabClients = new MatTableDataSource(res.content);
                    setTimeout(() => this.tabClients.paginator = this.paginator);
                    this.tabClients.sort = this.sort;
                    this.tabClients.filterPredicate = (data: Client, filter: string) => {
    
                        return data.name.trim().toLowerCase().includes(filter);
                    };
                } else {
                    this.errorTypeListClient = res.result;
                    this.errorMessageListClient = res.content;
                }
            }, (resError) => {
                this.errorService.errorType = "ERROR";
                this.errorService.errorMessage = resError.error.detail;
                this.route.navigate(['/error']);
            });
        }

        this.tabUpdated = true;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.tabClients.filter = filterValue;
    }

    infoClient(client: Client) {
        const modalRef = this.modalService.open(ClientInfoComponent, {size: 'lg', centered: true});
        modalRef.componentInstance.clientID = client.id;
        modalRef.result.then((data) => {
            this.tabUpdated = false;     
        }, (reason) => {
            this.tabUpdated = false;
        })
    }

    downloadLoadClient() {
        const filename = "loadclient.xlsx";
        this.loader.show("OPEN.DOWNLOAD-ATTACHMENT", {filename :  filename});
        this.downloadService.downloadFile(filename).subscribe(blob => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(blob)
            a.href = objectUrl
            a.download = filename;
            a.click();
            URL.revokeObjectURL(objectUrl);
        })
        this.loader.hide();
    }

    fileUpdate() {
        if (this.fileInput.nativeElement.files.length > 0) {
            this.fileUpload = true;
        } else {
            this.fileUpload = false;
        }
    }

    async loadClient(attachment: any) {
        if (attachment.files.length > 0) {
            //@ts-ignore
            Array.from(attachment.files).forEach((file: File) => {
                let fileReader = new FileReader();
                fileReader.onload = async (e) => {
                    let text = fileReader.result;
                    this.loader.show("SPINNER-LOADER.LOADCLIENT", {filename : file.name});
                    const res = await this.superAdminService.loadClient(text, file.name);
                    this.loader.hide();
                    if (res.result == 'SUCCESS') {
                        this.tabUpdated = false;
                        this.resError = [];
                        this.resSuccess = [];
                        var line = 2;
                        for (const [key, loadClientResult] of Object.entries(res.content)) {
                            
                            if (loadClientResult) {
                                //@ts-ignore
                                for (const [resultClient, textResult] of Object.entries(loadClientResult)) {
                                    var msg = '[Ligne ' + line + '] ';
                                    if (resultClient == "SUCCESS") {
                                        //@ts-ignore
                                        var split = textResult.split("]");
                                        var msgs = split[1].trim().split(";");
                                        const clientName = msgs[msgs.length - 1];
                                        msgs.pop();
                                        this.translate.get(msgs, {structure: clientName}).subscribe(res => {
                                            for(const [errorName, errorValue] of Object.entries(res)) {
                                                msg = msg + errorValue + " ";
                                            }
                                            //@ts-ignore
                                            this.resSuccess.push(msg.trim());
                                        });
                                    } else {
                                        //@ts-ignore
                                        var split = textResult.split("]");
                                        var msgs = split[1].trim().split(";");
                                        const clientName = msgs[msgs.length - 1];
                                        msgs.pop();
                                        this.translate.get(msgs, {structure: clientName}).subscribe(res => {
                                            for(const [errorName, errorValue] of Object.entries(res)) {
                                                msg = msg + errorValue + " ";
                                            }
                                            //@ts-ignore
                                            this.resError.push(msg.trim());
                                        });
                                    }

                                }
                            }
                            line = line + 1;
                        }
                    } else {
                        this.errorMessageLoadClient = res.content;
                        this.errorTypeLoadClient = res.result;
                    }
                }
                fileReader.readAsDataURL(file);
            });
        } else {
            this.errorMessageLoadClient = "LOADPS.ERRORS.NO-FILE";
            this.errorTypeLoadClient = "ERROR";
        }
    }
}
